var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mail-folder__content-menu",class:{ hidden: !_vm.shown }},[_c('div',{ref:"contextMenuContent",staticClass:"content",style:({ top: `${_vm.position.top}px`, left: `${_vm.position.left}px` })},[(_vm.loading)?_c('div',{staticClass:"content-menu__loading"},[_c('Spin',{attrs:{"size":"large"}})],1):_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }